// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 20V2H2V22H22V20H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.0003 18.2096L21.0003 8.58592L15.3825 14.2033L12.4162 10.7426L6.00026 16.5567L6.00026 18.2096L21.0003 18.2096Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M6 14.7614L6.00037 12.0593L12.5898 6.06811L15.5566 9.52931L21.0003 4.08643V6.91021L15.4415 12.4682L12.4109 8.93254L6 14.7614Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-area-multi-filled')
export default class ChartAreaMultiFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-area-multi-filled',
    }
  }
}
